module.exports = __webpack_public_path__ + "static/media/arrow-down.610a50e8.svg";